<h5>Free Trial</h5>
<p>
  This is a free Trial account. To upgrade this account to a customer account as
  an Order Manager:
</p>
<p>This performs the following actions for you:</p>
<ul>
  <li>Set the <i>Subscription ID</i> you provide</li>
  <li>Set the <i>Account category</i> to External</li>
  <li>Clear the account <i>Expiration date</i></li>
  <li>
    Set the account limits below to the values corresponding to the
    <i>License package</i> as defined
    <a target="_blank" rel="noopener noreferrer" [href]="sharePointUrl">here</a>
  </li>
  <li>
    Set the
    <a routerLink="/au/accounts/{{ accountDetails?.id }}" fragment="licenses"
      ><i>License package</i></a
    >
    you provide
  </li>
</ul>
<p>
  <i class="fa fa-exclamation-triangle"></i> If the customer has negotiated
  custom account limits, you will need to set them manually below after
  performing the upgrade.
</p>
<p>
  <i class="fa fa-exclamation-triangle"></i> Trial account upgrade may disable
  some Tools depending on the new License package as defined
  <a target="_blank" rel="noopener noreferrer" [href]="sharePointUrl">here</a>.
  When the upgrade is complete, review the
  <a
    routerLink="/au/accounts/{{ accountDetails?.id }}"
    fragment="feature-toggles"
    ><i>Feature toggles</i></a
  >
  tab and ensure all Tools purchased by the customer are enabled.
</p>
<div class="upgrade">
  <button
    [disabled]="
      progress ||
      !hasOrderManagerRole ||
      accountDetails?.state !== AccountState.Success
    "
    class="btn btn-primary"
    [ngbTooltip]="tooltipMessage()"
    (click)="showUpgrade()"
  >
    <i class="far fa-arrow-alt-circle-up icon"></i><span>Upgrade</span
    ><app-loading-spinner *ngIf="progress" size="sm"></app-loading-spinner>
  </button>
</div>
